import { Box, Button, Typography, useMediaQuery, useTheme } from '@mui/material'
import { IconCalendarEvent, IconLink } from '@tabler/icons-react'
import { Link } from 'react-router-dom'
import { Calendar } from '~/assets/illustrations'
import { useAuth, usePartner } from '~/contexts'


export const NewCalendar: React.FC<{ arrowColor?: string }> = () => {
  const { myPartner } = usePartner()
  const { authUser } = useAuth()
  const theme = useTheme()
  const isLowerSm = useMediaQuery(theme.breakpoints.down('sm'))
  const isLowerMd = useMediaQuery(theme.breakpoints.down('md'))

  if (authUser?.owner === false) return null

  return (
    <Box sx={{
      gap: '24px',
      padding: isLowerSm ? 2 : 4,
      display: 'flex',
      background: theme.palette.secondary.light,
      borderRadius: '12px',
      position: 'relative',
      flexDirection: 'column',
      border: `1px solid ${theme.palette.secondary.main}`,
    }}>
      {!isLowerMd && <Calendar style={{ position: 'absolute', top: '0px', right: '32px', fontSize: 200 }} />}
      <Box sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '20px',
        maxHeight: 'fit-content',
      }}>
        <Box sx={{
          padding: '16px',
          display: 'flex',
          borderRadius: '8px',
          alignItems: 'center',
          maxWidth: '34px',
          maxHeight: '34px',
          background: '#56188533',
          justifyContent: 'center',

        }}>
          <IconCalendarEvent color={theme.palette.secondary.main} size={16} style={{
            minWidth: '16px'
          }} />
        </Box>
        <Typography variant='h3' color={theme.palette.grey[700]} fontWeight={600}>
          Novo calendário de comissões
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', flexFlow: 'column' }}>
        <Typography sx={{ lineHeight: isLowerSm ? '150%' : '32px', maxWidth: '460px', fontSize: '16px' }}>
          Deixamos tudo mais simplificado para você:
        </Typography>
        <Typography fontWeight={600} sx={{ lineHeight: isLowerSm ? '150%' : '32px', maxWidth: '480px', fontSize: '16px' }}>
          Apuração: de 1º a 30/31
        </Typography>
        <Typography fontWeight={600} sx={{ lineHeight: isLowerSm ? '150%' : '32px', maxWidth: '460px', fontSize: '16px' }}>
          Pagamento: até o dia 15 do mês seguinte
        </Typography>
        <Typography sx={{ lineHeight: isLowerSm ? '150%' : '32px', maxWidth: '686px', fontSize: '16px' }}>
          Essa mudança <span style={{ fontWeight: 600 }}>substitui o modelo anterior (do dia 21 ao dia 20, com pagamento até o dia 5)</span> trazendo mais organização, alinhamento com nossos ciclos internos e segurança para todos.
        </Typography>
        <Typography sx={{ lineHeight: isLowerSm ? '150%' : '32px', maxWidth: '686px', fontSize: '16px' }}>
          🔄 Mês de transição: os pagamentos seguem normalmente, e o novo calendário <br />
          já começa a valer no próximo ciclo.
        </Typography>
      </Box>
    </Box >
  )
}
